export default __webpack_public_path__ + "static/media/ghost-1.e317155c.png";